import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Thematique from '../Entity/Thematique'

/**
* Class ThematiqueList
* ThematiqueList view component
**/
class ThematiqueList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Thematique;

    // Filter list
    const filters = [{
      title: "Nom de la thématique",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes thématiques</h2>
        <GridFilter title="Filtrer les thématiques" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Thématiques" ref={"grid" + objectClass.name} path="thematiques" objectPath="thematiques" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Thematique.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Thematique.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Thematique.name];
    grid.clearFilters();
  }

}
export default ThematiqueList;



// WEBPACK FOOTER //
// ./src/views/Search/ThematiqueList.js